__turbopack_context__.v({
  "category": "CommandPalette-module__Y7BVMa__category",
  "clearButton": "CommandPalette-module__Y7BVMa__clearButton",
  "container": "CommandPalette-module__Y7BVMa__container",
  "fadeIn": "CommandPalette-module__Y7BVMa__fadeIn",
  "footer": "CommandPalette-module__Y7BVMa__footer",
  "footerItem": "CommandPalette-module__Y7BVMa__footerItem",
  "input": "CommandPalette-module__Y7BVMa__input",
  "inputIcon": "CommandPalette-module__Y7BVMa__inputIcon",
  "inputWrapper": "CommandPalette-module__Y7BVMa__inputWrapper",
  "item": "CommandPalette-module__Y7BVMa__item",
  "itemContent": "CommandPalette-module__Y7BVMa__itemContent",
  "itemDescription": "CommandPalette-module__Y7BVMa__itemDescription",
  "itemIcon": "CommandPalette-module__Y7BVMa__itemIcon",
  "itemLabel": "CommandPalette-module__Y7BVMa__itemLabel",
  "key": "CommandPalette-module__Y7BVMa__key",
  "noResults": "CommandPalette-module__Y7BVMa__noResults",
  "overlay": "CommandPalette-module__Y7BVMa__overlay",
  "results": "CommandPalette-module__Y7BVMa__results",
  "selected": "CommandPalette-module__Y7BVMa__selected",
  "shortcut": "CommandPalette-module__Y7BVMa__shortcut",
  "slideDown": "CommandPalette-module__Y7BVMa__slideDown",
});
